import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Indication from './components/Indication.vue';
import Widget from './components/Widget.vue';
import Nav from './components/Nav.vue';
import Meta from 'vue-meta';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach((rule) => {
    extend(rule, rules[rule]);
});
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
Vue.component('irsh-indication', Indication);
Vue.component('irsh-widget', Widget);
Vue.component('irsh-nav', Nav);
import store from './store';
import BootstrapVue from 'bootstrap-vue';

Vue.use(Meta);
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/scss/app.scss';

import PrimeVue from 'primevue/config';

Vue.use(PrimeVue, { unstyled: true });

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    const hashPathMap = {
        '#efficacy': 'adhd-medication-efficacy',
        '#pk-profile': 'pk-data',
        '#dosingtitration': 'dosing',
        '#mod': 'pk-data#moa',
        '#savings-and-support': 'savings',
        '#dose-dependent': 'methylphenidate-dosage-duration',
        '#why-choose-jornay-pm': '/',
    };

    if (to.hash && hashPathMap[to.hash]) {
        next({ path: hashPathMap[to.hash], replace: true });
    } else {
        next();
    }
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
